var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pagination-box mt-4 mb-3" },
    [
      _c(
        "v-layout",
        {
          staticClass: "mx-4",
          attrs: { row: "", "justify-space-between": "" }
        },
        [
          _c(
            "div",
            [
              _c("v-layout", { attrs: { row: "", "align-center": "" } }, [
                _c("span", [_vm._v("Mostrar")]),
                _c(
                  "span",
                  { staticClass: "input-container ml-2 mr-2 mb-2" },
                  [
                    _c("v-select", {
                      staticClass: "pt-0",
                      attrs: { items: _vm.rows, "hide-details": "" },
                      on: { change: _vm.emit },
                      model: {
                        value: _vm.pageSize,
                        callback: function($$v) {
                          _vm.pageSize = _vm._n($$v)
                        },
                        expression: "pageSize"
                      }
                    })
                  ],
                  1
                ),
                _c("span", [_vm._v("registros por página")])
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "text-xs-center" },
            [
              _c("ul", { staticClass: "v-pagination" }, [
                _c("li", [
                  _c(
                    "button",
                    {
                      staticClass: "btn-pag-all v-pagination__navigation",
                      class: {
                        "v-pagination__navigation--disabled":
                          _vm.pageAllLeftDisabled
                      },
                      attrs: { disabled: _vm.pageAllLeftDisabled },
                      on: { click: _vm.allLeft }
                    },
                    [_c("i", { staticClass: "icon-ic-pag-all-left" })]
                  )
                ])
              ]),
              _c("v-pagination", {
                attrs: {
                  length: _vm.totalPages,
                  "total-visible": 7,
                  circle: "",
                  "prev-icon": "icon-ic-pag-left",
                  "next-icon": "icon-ic-pag-right"
                },
                on: { input: _vm.emit },
                model: {
                  value: _vm.pageNumber,
                  callback: function($$v) {
                    _vm.pageNumber = $$v
                  },
                  expression: "pageNumber"
                }
              }),
              _c("ul", { staticClass: "v-pagination" }, [
                _c("li", [
                  _c(
                    "button",
                    {
                      staticClass: "btn-pag-all v-pagination__navigation",
                      class: {
                        "v-pagination__navigation--disabled":
                          _vm.pageAllRightDisabled
                      },
                      attrs: { disabled: _vm.pageAllRightDisabled },
                      on: { click: _vm.allRight }
                    },
                    [_c("i", { staticClass: "icon-ic-pag-all-right" })]
                  )
                ])
              ])
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "v-layout",
                { staticClass: "mt-1", attrs: { row: "", "align-center": "" } },
                [
                  _c("span", [_vm._v("Ir a la página")]),
                  _c(
                    "span",
                    { staticClass: "ml-2 mt-2" },
                    [
                      _c("v-text-field", {
                        ref: "pageNumberInput",
                        staticClass: "input-container-2 pt-0",
                        attrs: {
                          type: "number",
                          "single-line": "",
                          "hide-details": ""
                        },
                        on: {
                          input: _vm.manualChangePage,
                          keypress: _vm.onlyNumbers
                        },
                        model: {
                          value: _vm.pageNumber,
                          callback: function($$v) {
                            _vm.pageNumber = _vm._n($$v)
                          },
                          expression: "pageNumber"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e9f2d1bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9f2d1bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/pagination-box.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e9f2d1bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/pagination-box.vue
// module chunks = 34